const language = {
	spanish: {
		header_title: "Construcción",
		flotas_red_title: "MANEJO DE FLOTAS",
		flotas_bold_title:
			"Cuando administra una flota de vehículos y equipo pesado en construcción, debe saber dónde está todo y qué está haciendo en todo momento.",
		flotas_bold_text:
			"G-Evolution ayuda a las empresas de construcción a rastrear vehículos y activos tanto durante la jornada laboral como durante el almacenamiento, aumentando así la eficiencia y reduciendo el robo y el desperdicio.",
		flotas_text: [
			"Los equipos y máquinas inactivos o infrautilizados pueden costarle mucho dinero a las compañías de construcción, no solo por el excesivo uso de combustible sino por el los tiempos muertos de las unidades.",
			"Con la gestión de flotas de equipos pesados y de técnicos en campo en el sector de la construcción, puede ver lo que está sucediendo y dónde está sucediendo para tomar decisiones sobre recursos más informados.",
		],
		beneficios_list: [
			{
				text: "Seguimiento en tiempo real de activos pesados, móviles o estacionarios, y personal de campo.",
				column: "1",
			},
			{
				text: "Variedad de sensores para combustible de maquinaria y vehículos.",
				column: "1",
			},
			{
				text: "Central de control de rutas para la distribución de materia prima costosa.",
				column: "1",
			},
			{
				text: "Control para manejo de operadores.",
				column: "1",
			},
			{
				text: "Sistema de control en mezcla de concreto.",
				column: "1",
			},
			{
				text: "Seguridad de activos mejorada.",
				column: "2",
			},
			{
				text: "Reubica equipos de forma precisa.",
				column: "2",
			},
			{
				text: "Mantenimiento preventivo de unidades.",
				column: "2",
			},
			{
				text: "Control efectivo de horas de trabajo de personal en campo.",
				column: "2",
			},
			{
				text: "Soporte de servicio 24/7.",
				column: "2",
			},
		],
		caracteristicas_red_title: "CARACTERÍSTICAS",
		caracteristicas_bold_text:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			"Eventos configurables dependiendo de la operación.",
			"Restricción de descarga de concreto con geocercas digitalizadas.",
			"Alerta de encendido de maquinaria en horarios determinados.",
			"Video en tiempo real de operación en campo.",
			"Obtenga alertas instantáneas de operación no autorizada las 24h.",
			"Alertas de desvió de rutas de entrega de materia prima.",
			"Sensores de temperatura en equipos.",
			"Obtener velocidad y sentido de giro de mezcladora de concreto.",
			"Conjunto de reportes para verificar operación de flota y personal de campo.",
		],
		automatizacion_bold_title: "Automatización de alertas de mantenimiento",
		automatizacion_text: [
			"Las averías inesperadas pueden provocar el incumplimiento de los plazos, la pérdida de ingresos y la insatisfacción de los clientes.El rastreo vía GPS y la telemática de alta calidad en equipos de construcción puede mantenerlo actualizado sobre las necesidades de mantenimiento y ayudarle a programar el servicio proactivo de manera.",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Fue diseñado para visualizar los indicadores clave de rendimiento de forma rápida y eficiente, facilitando la toma de decisiones ante grandes volúmenes de datos",
		dashboard_bold_text:
			"Con distintos conjuntos de tableros puedes ver la distancia recorrida por cada miembro del equipo, entradas y salidas de áreas geográficas determinadas, horas de trabajo activo y el tiempo en rutas, y más.",
		dashboard_list: [
			"Procesamiento de data.",
			"Presentación gráfica de resultados.",
			"Comparativo de resultados entre diferentes vehículos.",
			"Identificador de variables fuera de rango.",
			"Interfaz gráfica amigable y fácil de leer.",
			"Control de múltiples variables de manera simultánea.",
			"Información discriminada en piloto/embarcación y flota.",
		],
	},
	english: {
		header_title: "Construction",
		flotas_red_title: "FLEET MANAGEMENT",
		flotas_bold_title:
			"When managing a fleet of construction vehicles and heavy equipment, you need to know where everything is and what it is always doing.",
		flotas_bold_text:
			"G-Evolution helps construction companies track vehicles and assets both during the workday and while it is in storage. This tracking increases the efficiency and reduces theft and waste.",
		flotas_text: [
			"Idle or underutilized equipment and machines can cost construction companies a lot of money, not only because of its fuel use, but also because of the units’ downtime.",
			"With fleet management of heavy equipment and field technicians in the construction industry, you can see what is happening and evaluate the situation to make more informed resource decisions.",
		],
		beneficios_list: [
			{
				text: "Real time tracking of heavy, mobile, or stationary assets, also field personnel.",
				column: "1",
			},
			{
				text: "Variety of fuel sensors for machinery and vehicles.",
				column: "1",
			},
			{
				text: "Route control center for the distribution of expensive raw materials.",
				column: "1",
			},
			{
				text: "Operator management.",
				column: "1",
			},
			{
				text: "Control system in concrete mix.",
				column: "1",
			},
			{
				text: "Enhanced asset security.",
				column: "2",
			},
			{
				text: "Accurate relocation of equipment.",
				column: "2",
			},
			{
				text: "Preventive maintenance of units.",
				column: "2",
			},
			{
				text: "Effective staff control of hours in the field.",
				column: "2",
			},
			{
				text: "24/7 hours support.",
				column: "2",
			},
		],
		caracteristicas_red_title: "FEATURES",
		caracteristicas_bold_text:
			"We have the best technological innovation for optimal tracking of your mobile assets:",
		caracteristicas_list: [
			"These features can be configurable depending on the operation.",
			"Concrete discharge restriction with digital geofences.",
			"Machinery ignition alerts.",
			"Real time video of field operation.",
			"Instant alerts of unauthorized operations 24 hours a day.",
			"Alerts of deviation of raw material delivery routes.",
			"Temperature sensors on the equipment.",
			"Reports to verify fleet operation and field personnel.",
		],
		automatizacion_bold_title: "       Automation of maintenance alerts",
		automatizacion_text: [
			"Unexpected breakdowns can lead to missed deadlines, lost revenue, and customer       dissatisfaction. High quality construction equipment telematics and GPS tracking can keep you informed of maintenance needs and help you schedule proactive service more efficiently.",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Designed to display key performance indicators quickly and efficiently, facilitating      decision making when faced with large volumes of data.",
		dashboard_bold_text:
			"With different sets of dashboards allow you to view fleet average, maximum and average speed, milage per unit, average of fuel consumption of the fleet or individual, engine running hours, and more.",
		dashboard_list: [
			"Data processing.",
			"Graphic presentation of results.",
			"Comparison of results between different vehicles.",
			"Out of range variable identifier.",
			"User friendly and easy to read graphical interface",
			"Simultaneous control of multiple variables",
			"Information on driver, vehicle, and fleet",
		],
	},
};

export default language;